<template>
  <div class="d-flex justify-content-between align-items-center">
    <div class="input-wrapper" @click="enableOrderInput" :class="{ 'input-disabled': disabled || locked, 'input-locked': locked }">
      <input
        :type="type"
        class="form-control"
        :class="classString"
        :disabled="disabled || locked"
        :style="styleString"
        @change="changed = true"
        @blur="disableInput"
        @keyup.enter="blurInput"
        :ref="`orderInputField-${blurIndex}`"
        v-model="value"
      >
      <button v-if="disabled && !locked" class="enable-input-btn"></button>
      <button v-if="!disabled && !locked" @mousedown.prevent.stop="prepareToClear" @mouseup.stop="clearInput" class="clear-input-btn">
        <i class="bi bi-x"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditOrderProp',
  props: {
    orderProperty: { type: Object, default: () => ({}) },
    classStr: { type: String, default: '' },
    styleStr: { type: String, default: '' },
    round: { type: Number, default: undefined },
    type: { type: String, default: 'text' },
    blurIndex: { type: [Number, String], default: 0 },
    locked: { type: Boolean, default: false }
  },
  emits: ['changed'],
  data() {
    return {
      orderProp: {},
      changed: false,
      classString: '',
      styleString: '',
      value: null,
      disabled: true,
      clearInProgress: false,
    }
  },
  watch: {
    orderProperty() {
      this.init();
    }
  },
  methods: {
    enableOrderInput() {
      if (this.locked) return;
      console.log(`enableOrderInput() orderInputField-${this.blurIndex}`)
      this.disabled = false;
      this.$nextTick(() => {
        this.$refs[`orderInputField-${this.blurIndex}`].focus();
      });
    },
    disableInput() {
      if (!this.clearInProgress) { 
        this.disabled = true;
        this.saveOrderProp();
      }
    },
    async saveOrderProp() {
      if(this.changed) {
        this.$emit('changed', this.value, this.blurIndex);
      }
    },
    blurInput() {
      this.$refs[`orderInputField-${this.blurIndex}`].blur();
    },
    prepareToClear() {
      this.clearInProgress = true;
    },
    clearInput() {
      this.value = '';
      this.clearInProgress = false;
    },
    init() {
      this.orderProp = this.orderProperty
      this.styleString = this.styleStr
      this.classString = this.classStr
      if(this.round !== undefined) {
        let val = this.orderProperty.value
        if(typeof val !== 'number' ) {
          val = Number(val)
        }
        this.value = val.toFixed(this.round)
      } else {
        this.value = this.orderProperty.value
      }
    },
  },
  created() {
    this.init();
  }
}
</script>

<style scoped>
.enable-input-btn {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  cursor: pointer;
}

.input-wrapper {
  position: relative;
  display: inline-block;
}

.input-disabled input {
  cursor: pointer;
}

.input-locked input {
  cursor: not-allowed;
  background-color: #f1f3f5;
}

.input-locked .enable-input-btn,
.input-locked .clear-input-btn {
  display: none;
}

.clear-input-btn {
  position: absolute;
  right: 0.5em;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  width: 1.5em;
  height: 1.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: #f8f9fa;
}

.clear-input-btn:hover {
  background-color: #e0e0e0;
}

.clear-input-btn i {
  font-size: 1em;
  color: #6c757d;
}

.input-wrapper input {
  padding-right: 2em;
}
</style>